<template>
  <v-card
      class=""

  >
    <v-card-title class="justify-center">{{statName}}</v-card-title>
    <v-card-text class="text-center">
      <div v-if="isLoading">
        <v-progress-circular
            indeterminate
            color="red"
        ></v-progress-circular>
      </div>
      <div v-else class="text-h4">{{stateValue.toLocaleString() }}</div>
    </v-card-text>

  </v-card>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    statName: String,
    stateValue: Number,
    loading: Boolean
  },
  computed: {
    isLoading: function () {
      return this.stateValue == null;
    },
  }
}
</script>

<style scoped>

</style>
